import request from '@/router/axios';
const urlPrefix = '/sys'
//获取客户下的分公司机构
export function getCompanyOrg(cusId) {
  return request({
    url: urlPrefix+`/org/cus/company/${cusId}`,
    method: 'get',
  })
}

//获取客户下的分公司机构
export function getOrgInfo(cusId) {
  return request({
    url: urlPrefix+`/org/cus/${cusId}`,
    method: 'get',
  })
}

export function companyOrgFilter(orgId, orgList) {
  debugger;
  for(var i=0;orgList!=null && i<orgList.length;i++){
    var org = orgList[i];
    if(org.id == orgId){
      return org.orgName;
    }
  }
}
//根据不同条件查询雇员部门信息
export function getEmpDeptList(obj) {
  return request({
    url: urlPrefix+'/org/queryEmpDeptInfoForList',
    method: 'get',
    params:obj
  })
}
